/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from "react";

function debounce<Params extends any[]>(
  func: (...args: Params) => any,
  timeout: number,
): (...args: Params) => void {
  let timer: NodeJS.Timeout;
  return (...args: Params) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, timeout);
  };
}
const getWindowDimensions = () => {
  let width = 0;
  if (window?.visualViewport) {
    const scrollBarWidth = window.innerWidth - window.visualViewport.width;
    width = window.visualViewport.width + scrollBarWidth;
  } else {
    width = window.innerWidth;
  }

  return { width };
};

export default function useWindowDimensions(mounted: boolean) {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );

  useEffect(() => {
    function handleResize() {
      if (mounted) {
        setWindowDimensions(getWindowDimensions());
      }
    }

    window.addEventListener("resize", debounce(handleResize, 300));
    return () => window.removeEventListener("resize", handleResize);
  }, [mounted]);

  return windowDimensions;
}
